import * as React from 'react';

import Picture16 from './Picture16';

export const picture16 = () => <Picture16 />;

export default {
    title: 'Icon|Fill|Picture16',
    component: Picture16,
    parameters: {
        notes: "`import Picture16 from 'box-ui-elements/es/icon/fill/Picture16';`",
    },
};
